document.querySelectorAll('[data-svrn-pdp]').forEach((page) => {
  const select = page.querySelector('[data-svrn-variant]');
  const price = page.querySelector('.svrn-pdp__price strong');
  const stickyPrice = page.querySelector('[data-svrn-sticky-price]');
  const quantity = page.querySelector('.svrn-pdp__form [name="quantity"]');
  page.querySelector('[data-pdp-qty-minus]')?.addEventListener('click', () => { quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1)); quantity.dispatchEvent(new Event('change', { bubbles: true })); });
  page.querySelector('[data-pdp-qty-plus]')?.addEventListener('click', () => { quantity.value = String(Math.min(9, Number(quantity.value || 1) + 1)); quantity.dispatchEvent(new Event('change', { bubbles: true })); });
  const checkout = page.querySelector('[data-svrn-pdp-checkout]');
  document.addEventListener('click', async (event) => {
    if (!checkout || !(event.target instanceof Element) || !event.target.closest('[data-svrn-pdp-checkout]') || !page.contains(event.target)) return;
    if (checkout.dataset.svrnCartReady === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkout.dataset.svrnPreparing === 'true') return;
    const form = checkout.closest('form');
    const variantId = Number(form?.querySelector('[name="id"]')?.value);
    const count = Math.max(1, Math.min(9, Number(quantity?.value || 1)));
    const error = form?.querySelector('[data-svrn-pdp-checkout-error]');
    const label = checkout.querySelector('span');
    if (!variantId) { if (error) { error.textContent = 'Please select an available product option.'; error.hidden = false; } return; }
    checkout.dataset.svrnPreparing = 'true';
    checkout.disabled = true;
    checkout.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Preparing checkout…';
    if (error) error.hidden = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: variantId, quantity: count }] }) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this product.');
      checkout.dataset.svrnCartReady = 'true';
      checkout.disabled = false;
      checkout.removeAttribute('aria-busy');
      if (label) label.textContent = 'Continue to checkout';
      checkout.click();
      delete checkout.dataset.svrnCartReady;
    } catch (problem) {
      if (error) { error.textContent = problem.message || 'Checkout could not be opened. Please try again.'; error.hidden = false; }
      checkout.disabled = false;
      checkout.removeAttribute('aria-busy');
      if (label) label.textContent = 'Continue to checkout';
    } finally { delete checkout.dataset.svrnPreparing; }
  }, true);
  if (select && price) {
    select.addEventListener('change', () => {
      const nextPrice = select.selectedOptions[0]?.dataset.price;
      if (!nextPrice) return;
      price.textContent = nextPrice;
      if (stickyPrice) stickyPrice.textContent = nextPrice;
    });
  }

  const gallery = page.querySelector('[data-svrn-gallery]');
  gallery?.querySelectorAll('[data-svrn-gallery-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const target = trigger.dataset.svrnGalleryTrigger;
      gallery.querySelectorAll('[data-svrn-gallery-panel]').forEach((panel) => {
        const active = panel.dataset.svrnGalleryPanel === target;
        panel.classList.toggle('is-active', active);
        if (!active) panel.querySelector('video')?.pause();
      });
      gallery.querySelectorAll('[data-svrn-gallery-trigger]').forEach((button) => {
        const active = button === trigger;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      const caption = gallery.querySelector('[data-svrn-gallery-caption]');
      if (caption) {
        caption.textContent = trigger.dataset.svrnGalleryDescription || '';
        caption.hidden = !caption.textContent;
      }
    });
  });
});
